export const ComplexTableColumnTypeEnum = Object.freeze({
    DEFAULT: 0,
    POINT: 1,
    ICON_COLOR: 2,
    IMAGE: 3,
});

export const ComplexTableColumnIconSiteEnum = Object.freeze({
    START: 0,
    End: 1,
});

export const ComplexTableSortedStatus = Object.freeze({
    DEFAULT: 0,
    ASC: 1,
    DESC: 2,
});

export const CaskLongTextInputElement = Object.freeze({
    FILE: 0,
    IMG: 1,
    EMOJI: 2,
    CALL: 3,
});

export const CaskModuleElement = Object.freeze({
    HOME: -1,
    ARTICLE: 0,
    ESSAY: 1,
    VIDEO: 2,
    GUEST_BOOK: 3,
    CHATROOM: 4,
    TOOL: 5,
});

export const CaskChatTypeEnum = Object.freeze({
    PRI: 0,
    GROUP: 1,
    NOTICE: 2,
    OPEN_GROUP: 3,
});